import DashaRow from "./DashaRow";
import DashaTableHeading from "./DashaTableHeading";

export default function DashaTable({
    data = [],
    timezone = "UTC",
    onClick,
    className,
}) {
    if (!data) return null;

    return (
        <table className="min-w-full border-collapse">
            <thead>
                <DashaTableHeading />
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <DashaRow
                        className={className}
                        key={index}
                        data={item}
                        timezone={timezone}
                        onClick={() => onClick(index)}
                    />
                ))}
            </tbody>
        </table>
    );
}
